import type { FileType } from '@/types'

interface FileIconProps {
  type: FileType
  size?: 'sm' | 'md' | 'lg'
}

const FILE_ICONS: Record<FileType, string> = {
  excel: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/item-types/32/xlsx.svg',
  word: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/item-types/32/docx.svg',
  powerpoint: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/item-types/32/pptx.svg',
  pdf: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/item-types/32/pdf.svg',
  folder: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/item-types/32/folder.svg',
}

const SIZE_MAP = {
  sm: 24,
  md: 32,
  lg: 48,
}

export function FileIcon({ type, size = 'md' }: FileIconProps) {
  const iconUrl = FILE_ICONS[type]
  const iconSize = SIZE_MAP[size]

  return (
    <img
      src={iconUrl}
      alt={type}
      style={{
        width: iconSize,
        height: iconSize,
        flexShrink: 0,
        display: 'block',
      }}
    />
  )
}
